import { i18n } from "@/shared/i18n/i18n";
import type { BioTariff } from "./backend";

export interface GasTariff {
  id: string;
  name: string;
  additionalInfo: string;
  price: {
    excludingVat: number;
    includingVat: number;
  };
}

export const mapToGasTariffType = (data: BioTariff): GasTariff => {
  const tariffId = data.name.toLocaleLowerCase();
  return {
    id: tariffId,
    name: i18n.t(`fbsHub.westfalengasBio.tariffList.${tariffId}.title`),
    additionalInfo: i18n.t(
      `fbsHub.westfalengasBio.tariffList.${tariffId}.additionalInfo`,
    ),
    price: {
      excludingVat: data.price.net,
      includingVat: data.price.gross,
    },
  };
};
